import { Action, createReducer, on } from '@ngrx/store';
import { AccountManagerDashboardState } from './../state/account-managers-dashboard.state';
import {
    getAccountManagerFollowups,
    getAccountManagerFollowupsFail,
    getAccountManagerFollowupsSuccess,
    getAccountManagerFollowupsSummary,
    getAccountManagerFollowupsSummaryFail,
    getAccountManagerFollowupsSummarySuccess
} from '../actions/account-managers-dashboard.actions';
import { AccountManagerDashboardFollowupType } from 'src/app/accountmanagers/dashboard/enums/account-manager-dashboard.enum';
import { AccountManagerDashboardFollowupItem } from 'src/app/accountmanagers/dashboard/models/account-manager-dashboard-tile-followups.model';

export const accountManagerDashboardFeatureKey = 'account-managers-dashboard';

export const initialState: AccountManagerDashboardState = {
    error: null,
    accountManagerSummary: null,
    accountManagerSummaryError: null,
    followups: {
        Today: [],
        Overdue: [],
        Completed: []
    }
};

const dashboardReducer = createReducer(
    initialState,

    // initiate followups fetch
    on(getAccountManagerFollowups, (state, action) => {
        return getFollowupsState(state, action.followupType, null);
    }),

    // successful followups fetched
    on(getAccountManagerFollowupsSuccess, (state, action) => {
        return getFollowupsState(state, action.followupType, action.followupItems);
    }),

    // followups fetch failure
    on(getAccountManagerFollowupsFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // initiate AM followups summary fetch
    on(getAccountManagerFollowupsSummary, (state, action) => ({
        ...state,
        accountManagerSummary: null
    })),

    // successful AM followups summary fetched
    on(getAccountManagerFollowupsSummarySuccess, (state, action) => ({
        ...state,
        accountManagerSummary: action.data
    })),

    // AM followups summary failure
    on(getAccountManagerFollowupsSummaryFail, (state, action) => ({
        ...state,
        accountManagerSummaryError: action.accountManagerSummaryError
    }))
);

function getFollowupsState(
    state: AccountManagerDashboardState,
    type: AccountManagerDashboardFollowupType,
    items: AccountManagerDashboardFollowupItem[]
): AccountManagerDashboardState {
    switch (type) {
        case AccountManagerDashboardFollowupType.Today:
            return { ...state, followups: { ...state.followups, Today: items } };
        case AccountManagerDashboardFollowupType.Overdue:
            return { ...state, followups: { ...state.followups, Overdue: items } };
        case AccountManagerDashboardFollowupType.Completed:
            return { ...state, followups: { ...state.followups, Completed: items } };
    }

    return { ...state };
}

export function reducer(state: AccountManagerDashboardState | undefined, action: Action) {
    return dashboardReducer(state, action);
}
